import { Naming_UIElement, Naming_UIElement__get_asString, Naming_mkIdFromStrings } from "../fable_modules/Webbler.Models.1.6.0/Common.fs.js";
import { empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { CSSProp, DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { isNullOrEmpty, printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";
import { totalMinutes, totalSeconds } from "../fable_modules/fable-library-js.4.19.3/TimeSpan.js";
import { utcNow, op_Subtraction } from "../fable_modules/fable-library-js.4.19.3/DateOffset.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { Helpers_nothing } from "../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { input } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "../fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { empty, append, singleton, map, delay, toList, filter, truncate, toArray } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { isDigit } from "../fable_modules/fable-library-js.4.19.3/Char.js";
import { item, iterateIndexed } from "../fable_modules/fable-library-js.4.19.3/Array.js";
import { MfaModel__get_MfaCode, Msg } from "./AuthTypes.js";
import { min } from "../fable_modules/fable-library-js.4.19.3/Double.js";
import { equals } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.19.3/Range.js";
import { Option as Option_1, button } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { container } from "../fable_modules/Fulma.3.0.0/Layouts/Container.fs.js";
import { Option as Option_2, h3 } from "../fable_modules/Fulma.3.0.0/Elements/Heading.fs.js";
import { Urls_Page, Urls_AuthPage, Urls_pageHash } from "../Common/General.js";

export function mkId(view_1, label, element) {
    return Naming_mkIdFromStrings(ofArray([view_1, label, Naming_UIElement__get_asString(element)]));
}

export function mkMfaViewId(label, element) {
    return new HTMLAttr(99, [mkId("MfaVerify", label, element)]);
}

function mfaDigitId(index) {
    return mkId("MfaVerify", toText(printf("Digit%d"))(index), new Naming_UIElement(0, []));
}

function expiryMessage(remaining) {
    let d;
    if (totalSeconds(remaining) <= 0) {
        return "Session expired";
    }
    else if (totalSeconds(remaining) < 30) {
        return "Session expires soon";
    }
    else if (totalMinutes(remaining) < 5) {
        const minutesBound = (1 + ~~((d = totalMinutes(remaining), Math.floor(d)))) | 0;
        if (minutesBound <= 1) {
            return "Session expires in less than 1 minute";
        }
        else {
            return toText(printf("Session expires in less than %d minutes"))(minutesBound);
        }
    }
    else {
        const arg_1 = ~~Math.floor(totalMinutes(remaining)) | 0;
        return toText(printf("Session expires in %d minutes"))(arg_1);
    }
}

function renderExpiryIndicator(expiresAt) {
    if (expiresAt != null) {
        const remaining = op_Subtraction(expiresAt, utcNow());
        const message = expiryMessage(remaining);
        const colorClass = (totalSeconds(remaining) <= 0) ? "has-text-danger" : ((totalSeconds(remaining) < 30) ? "has-text-warning" : "has-text-grey");
        const props = [new HTMLAttr(64, [toText(printf("is-size-7 %s"))(colorClass)]), ["style", {
            textAlign: "center",
            marginTop: "0.5rem",
        }]];
        return react.createElement("p", keyValueList(props, 1), message);
    }
    else {
        return Helpers_nothing;
    }
}

function renderDigitInput(index, value, isVerifying, dispatch) {
    return input(ofArray([new Option(1, [new IInputType(0, [])]), new Option(15, [ofArray([new HTMLAttr(99, [mfaDigitId(index)]), new HTMLAttr(115, [1]), new HTMLAttr(79, [isVerifying]), new HTMLAttr(54, ["one-time-code"]), ["style", {
        width: "3rem",
        height: "3.5rem",
        fontSize: "1.5rem",
        textAlign: "center",
        margin: "0 0.25rem",
    }], new DOMAttr(2, [(e) => {
        e.preventDefault();
        const digits = toArray(truncate(6, filter(isDigit, e.clipboardData.getData("text").split(""))));
        iterateIndexed((i, digit) => {
            if ((i + index) < 6) {
                dispatch(new Msg(18, [i + index, digit]));
            }
        }, digits);
        const targetIndex = min(index + digits.length, 5) | 0;
        const targetInput = document.getElementById(mfaDigitId(targetIndex));
        if (!(targetInput == null)) {
            targetInput.focus();
        }
    }]), new DOMAttr(15, [(e_1) => {
        if (((e_1.key === "Backspace") && isNullOrEmpty(value)) && (index > 0)) {
            const prevInput = document.getElementById(mfaDigitId(index - 1));
            if (!(prevInput == null)) {
                prevInput.focus();
            }
        }
    }]), new DOMAttr(10, [(e_2) => {
        const newValue = e_2.currentTarget.value;
        let digit_1;
        if (isNullOrEmpty(newValue)) {
            digit_1 = "";
        }
        else if (newValue.length >= 1) {
            const lastChar = newValue[newValue.length - 1];
            digit_1 = (isDigit(lastChar) ? lastChar : "");
        }
        else {
            digit_1 = "";
        }
        dispatch(new Msg(18, [index, digit_1]));
        if (!isNullOrEmpty(digit_1) && (index < 5)) {
            const nextInput = document.getElementById(mfaDigitId(index + 1));
            if (!(nextInput == null)) {
                nextInput.focus();
            }
        }
    }])])]), new Option(8, [value]), new Option(14, [(e_3) => {
        if (!(e_3 == null)) {
            if (!equals(e_3.value, value)) {
                e_3.value = value;
            }
        }
    }])]));
}

function renderCodeInput(model, dispatch) {
    const props = [["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: "1.5rem",
    }]];
    const children = toList(delay(() => map((i) => renderDigitInput(i, item(i, model.mfaModel.MfaCodeDigits), model.mfaModel.MfaIsVerifying, dispatch), rangeDouble(0, 1, 5))));
    return react.createElement("div", keyValueList(props, 1), ...children);
}

function renderMfaButtonRow(model, dispatch) {
    let props_6, children_6;
    let cooldownMsg;
    const props_4 = [["style", {
        textAlign: "center",
        marginBottom: "0.5rem",
        minHeight: "1.25rem",
    }]];
    const children_4 = toList(delay(() => {
        let children;
        const matchValue = model.mfaModel.MfaCooldownSeconds;
        if (matchValue == null) {
            return singleton(react.createElement("span", {}, ""));
        }
        else {
            const seconds = matchValue | 0;
            return singleton((children = [toText(printf("Code resend is available in %d seconds"))(seconds)], react.createElement("span", {
                className: "has-text-grey",
            }, ...children)));
        }
    }));
    cooldownMsg = react.createElement("div", keyValueList(props_4, 1), ...children_4);
    const canResend = (model.mfaModel.MfaCooldownSeconds == null) && !model.mfaModel.MfaIsVerifying;
    const canVerify = (MfaModel__get_MfaCode(model.mfaModel).length === 6) && !model.mfaModel.MfaIsVerifying;
    const children_8 = [cooldownMsg, (props_6 = [["style", {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    }]], (children_6 = [button(ofArray([new Option_1(17, [singleton_1(mkMfaViewId("Verify", new Naming_UIElement(2, [])))]), new Option_1(0, [new Color_IColor(4, [])]), new Option_1(13, [model.mfaModel.MfaIsVerifying]), new Option_1(16, [!canVerify]), new Option_1(17, [ofArray([["style", {
        minWidth: "8rem",
    }], new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(19, []));
    }])])])]), singleton_1("Verify")), button(ofArray([new Option_1(17, [singleton_1(mkMfaViewId("Resend", new Naming_UIElement(2, [])))]), new Option_1(0, [new Color_IColor(7, [])]), new Option_1(16, [!canResend]), new Option_1(17, [ofArray([["style", keyValueList(toList(delay(() => append(singleton(new CSSProp(224, ["1rem"])), delay(() => append(singleton(new CSSProp(253, ["8rem"])), delay(() => (!canResend ? append(singleton(new CSSProp(261, ["0.5"])), delay(() => singleton(new CSSProp(123, ["not-allowed"])))) : empty()))))))), 1)], new DOMAttr(40, [(e) => {
        e.preventDefault();
        if (canResend) {
            dispatch(new Msg(21, []));
        }
    }])])])]), singleton_1("Resend code"))], react.createElement("div", keyValueList(props_6, 1), ...children_6)))];
    return react.createElement(react.Fragment, {}, ...children_8);
}

export function view(model, dispatch) {
    let props_2, children, props_6, children_4, props_4;
    return container(empty_1(), ofArray([h3(singleton_1(new Option_2(9, [singleton_1(["style", {
        textAlign: "center",
    }])])))(singleton_1("Two-Factor Authentication")), (props_2 = [["style", {
        textAlign: "center",
        marginBottom: "1.5rem",
    }]], (children = ["A 6-digit verification code has been sent to your email.", react.createElement("br", {}), "Please enter the code below to complete login."], react.createElement("p", keyValueList(props_2, 1), ...children))), renderCodeInput(model, dispatch), renderExpiryIndicator(model.mfaModel.MfaExpiresAt), renderMfaButtonRow(model, dispatch), (props_6 = [["style", {
        textAlign: "center",
        marginTop: "1.5rem",
    }]], (children_4 = [(props_4 = [mkMfaViewId("BackToLogin", new Naming_UIElement(2, [])), new HTMLAttr(94, [Urls_pageHash(new Urls_Page(0, [new Urls_AuthPage(0, [])]))]), new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(25, []));
    }])], react.createElement("a", keyValueList(props_4, 1), "← Back to login"))], react.createElement("div", keyValueList(props_6, 1), ...children_4)))]));
}

